import React from "react";
import {
  DisplayUpdateMedia
} from "../../_metronic/_partials";

export function UMedia(props) {
  return <DisplayUpdateMedia {...props} />;
}
